export default [{ value: 50, label: 'Career Teacher' },
{ value: 58, label: 'ESC' },
{ value: 40, label: 'Master Teacher' },
{ value: 41, label: 'Lead Teacher' },
{ value: 42, label: 'Mentor Teacher' },
{ value: 57, label: 'TA Provider' },
{ value: 56, label: 'TEA' },
{ value: 50, label: 'Teacher' }]